import URL from 'url'
/**
 * 使用方法
 *
 * cookieUtil.set('name', 'jobs', {hours: 1, domain: '.izhaowo.com'})
 *
 * Vue使用方法：this.cookie.set('name', 'jobs', {hours: 1})
 *
 * **/

const cookieUtil = {
    set: function(name, value, options) {
        const hours = (options && options.hours) || 24
        const domain = (options && options.domain) || ''

        const d = new Date()
        d.setTime(d.getTime() + 60 * 60 * 1000 * hours)
        const url = URL.parse(window.location.href)
        // console.log('value='+value.length)
        // for(let i of value){
        //     console.log(i.label)
        // }
        let curArry = ""
        if(value instanceof Array){
            for(let item of value){
                curArry += item.label+"_"+item.provincialCapitalEn+"_"+item.index+","
            }
            value = curArry

        }
        window.document.cookie = `${name}=${encodeURIComponent(
      value
    )};domain=${domain};path=/;expires=${d.toUTCString()}`
    },
    get: function(name) {
        if (typeof window === 'undefined') return ''
        const v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
        return v ? decodeURIComponent(v[2]) : null
    },
    delete: function(name, options) {
        const op = options || {}
        op.hours = -1
        this.set(name, '', op)
    },
    getCookieFormServer: function(name, cookie) {
        if (!cookie) return
        const v = cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
            // console.log('cook: ', v)
        let result = v && v.length > 2 ? decodeURIComponent(v[2]) : null
        return result ? result : ''
    },

    setCookieObject: function(name, value, options) {
        const hours = (options && options.hours) || 24
        const domain = (options && options.domain) || ''
        const d = new Date()
        d.setTime(d.getTime() + 60 * 60 * 1000 * hours)
        const val = JSON.stringify(value)
        window.document.cookie = `${name}=${encodeURIComponent(
            val
          )};domain=${domain};path=/;expires=${d.toUTCString()}`
    },
    getCookieObject: function(name) {
        if (typeof window === 'undefined') return ''
        const v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
        return v ? JSON.parse(decodeURIComponent(v[2])) : null
    },
    getCookieObjectFormServer: function(name, cookie) {
        if (!cookie) return
        const v = cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
        let result = v && v.length > 2 && v[2] && v[2] !== 'undefined' && decodeURIComponent(v[2]) ? JSON.parse(decodeURIComponent(v[2])) : null
        return result ? result : ''
    }
}

export default cookieUtil


// WEBPACK FOOTER //
// ./src/plugin/cookie.js